export interface HealthReading {
  reading_id: string;
  created_at: string;
  reading_data: Record<
    string,
    {
      value: number;
      category: string;
      score: number;
    }
  >;
  WELLNESS_INDEX: number;
  WELLNESS_LEVEL: string;
}

export type ScanReadingSubCategorisation = Record<
  string,
  {
    vital_key: string;
    subParameters: {
      vital_key: string;
    }[];
    display?: string;
  }[]
>;

export interface ScanReadings {
  readings: HealthReading[];
  config: Record<
    string,
    {
      display: string;
      unit: string;
      scale: unknown;
      color_range: Record<string, string[] | number[]>[];
      long_intro: string;
      scale_type: number;
      short_intro: string;
      variations?: boolean;
    }
  >;
  col_val: {
    Default: Record<string, Record<string, string>>;
  };
  category_config: Record<
    string,
    {
      unit: string;
      Parameter: string;
      sub_category: string;
      'Scale Criteria':
        | Record<string, string | number[]>
        | Record<string, Record<string, string | number[]>>;
    }
  >;
  sub_categorisation: ScanReadingSubCategorisation;
}

export interface ParameterHistory {
  custom_number: string;
  avg_value: string;
}

export interface ColorRange {
  range: (string | number)[];
  color: string;
  eng_category?: string | undefined;
}

export interface ReScanConfig {
  rescan_flag: boolean;
  error: string;
  error_msg: string;
}

export interface BinahSetting {
  setting_name: 'scan_duration' | 'sdk_key' | 'demographic_flag';
  setting_value: string;
  setting_id: string;
}

export interface ParameterHistoryParams {
  // filter_name?: string;
  type?: string;
  custom_filter?: Record<'start_date' | 'end_date', string>;
}

export interface HealthReadingData {
  reading_id: string;
  WELLNESS_INDEX: number;
  created_at: string;
  reading_source: string;
  medsi_wellness_score: string;
}

export interface HealthReadingDataResponse {
  count: number;
  reading_data: HealthReadingData[];
}

export interface InititaQRSession {
  url: string;
  session_id: string;
  device_token_flag: boolean;
}

export enum ScanLinkChannel {
  EMAIL = 'email',
  WHATSAPP = 'whatsapp',
  NOTIFICATION = 'notification',
}

export interface ScanErrorResponse {
  success: boolean;
  error_msg: Record<'header' | 'description', string>[];
  rescan: boolean;
  continue: boolean;
  exit_flag: boolean;
  error: boolean;
}
